import { staleReadSentence } from '@lib/stale-read';

/**
 * The red line over a list whose re-read failed (row 359 B): the rows stay, this says they are the
 * last good read, and Try again reads the same view again. Pair it with a disabled <fieldset> around
 * the table so no action can be taken on the stale rows.
 */
export function StaleNote({ at, err, onRetry }: { at: string; err: string; onRetry: () => void }): JSX.Element {
  return (
    <div className="note danger" style={{ marginBottom: 14, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }} data-testid="stale-note" title={err}>
      <span>{staleReadSentence(at)}</span>
      <button type="button" className="btn btn-sm btn-ghost" onClick={onRetry}>Try again</button>
    </div>
  );
}

/** The style that makes a disabled <fieldset> invisible: it only switches the controls inside it off. */
export const LOCK_FIELDSET_STYLE = { border: 0, padding: 0, margin: 0, minWidth: 0 } as const;
